import React, { useContext, useRef, useState } from 'react';
import {
  Box,
  TextField,
  Grid,
  Button,
  CircularProgress,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useConfirm } from 'material-ui-confirm';
import useStyles from '../styles';
import { ServiceContext } from 'context/ServiceContext';
import { BatchCancelTransactionRequest } from 'proto/trnspb/transaction_pb';
import {
  notifyError,
  notifySuccess,
} from 'components/Notification/Notification';
import {
  isBodRiskWindow,
  BOD_CANCEL_WARNING,
  cancelConfirmDescription,
} from 'lib/bodWindow';
import { useBodRiskWindow } from 'lib/useBodRiskWindow';

function CancelButton(props) {
  return (
    <Button
      variant="contained"
      color="primary"
      size="large"
      startIcon={
        props.loading ? (
          <CircularProgress
            style={{ color: '#ffffff', height: 20, width: 20 }}
          />
        ) : null
      }
      onClick={props.onClick}
    >
      {props.loading
        ? `Canceling ${props.numIDs} items...`
        : 'Cancel Transactions'}
    </Button>
  );
}

export default function CancelTransactionForm() {
  const classes = useStyles();
  const confirm = useConfirm();
  const [loading, setLoading] = useState(false);
  const [numIDs, setNumIDs] = useState(0);
  const showBodWarning = useBodRiskWindow();

  const textRef = useRef();

  const { transactionServiceClient } = useContext(ServiceContext);

  const executeBatchCancel = (lines) => {
    const req = new BatchCancelTransactionRequest();
    req.setTrnsIdsList(lines);
    setLoading(true);
    setNumIDs(lines.length);
    transactionServiceClient.batchCancelTransaction(req, {}, (err, res) => {
      setLoading(false);
      if (err) {
        notifyError(err.message);
        return;
      }
      let cancelCount = 0;
      console.log(res);
      console.log(res.toObject());
      res.toObject().transactionResponsesList.forEach((o) => {
        if (o.status === 'canceled') {
          cancelCount++;
        }
      });
      notifySuccess(`successully canceled ${cancelCount} items`);
    });
  };

  const onCancel = () => {
    const s = textRef.current.value;
    const lines = s
      .split('\n')
      .map((o) => o.trim())
      .filter((o) => o !== '');
    if (lines.length === 0) {
      notifyError('empty input');
      return;
    }

    if (isBodRiskWindow()) {
      confirm({
        description: cancelConfirmDescription(
          'You are about to cancel these transactions, please confirm.'
        ),
        confirmationText: 'Proceed anyway',
        cancellationText: 'Cancel',
      })
        .then(() => executeBatchCancel(lines))
        .catch(() => {
          /* user cancelled */
        });
      return;
    }

    executeBatchCancel(lines);
  };

  const onClear = () => {
    textRef.current.value = '';
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={6}>
        <Box className={classes.container}>
          {showBodWarning && (
            <Box mb={2}>
              <Alert severity="warning">{BOD_CANCEL_WARNING}</Alert>
            </Box>
          )}
          <Box display="flex" justifyContent="space-between">
            <CancelButton
              loading={loading}
              numIDs={numIDs}
              onClick={onCancel}
            ></CancelButton>
            <Button color="secondary" onClick={onClear}>
              Clear
            </Button>
          </Box>
          <TextField
            fullWidth
            multiline={true}
            rows={20}
            label="Transaction IDs:"
            placeholder="f009f937-49b3-494d-81c0-a1f40cb96fed
b98a638f-f404-4407-9e4d-fee6747d37b7
..."
            variant="outlined"
            className={classes.mt20}
            autoFocus
            inputRef={textRef}
          />
        </Box>
      </Grid>
      <Grid item xs={6}></Grid>
    </Grid>
  );
}
